import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../zustand/userStore";
import AllFeatureDataTable from "../../GuiComponents/AllFeatureDataTable.table";
import Popup from "../EventOrganiser/Popup";
import CreateStudent from "./CreateStudent";
import { fetchOrgStudents } from "./redux/quizSlice";

const Students = () => {
  const userData = userStore((state) => state.user);
  const { students, loading, error } = useSelector((state) => state.quiz);
  const dispatch = useDispatch();

  const userId = userData?.id;
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (userId) {
      dispatch(fetchOrgStudents());
    }
  }, [userId, dispatch]);

  const formattedStudents = students?.map((student, index) => ({
    sno: index + 1,
    name: student.student_name || student.user_name,
    email: student.student_email || student.user_email,
    student_class: student.student_class || "-",
    section: student.section || "-",
    roll_number: student.roll_number || "-",
    dob: student.dob || "-",
    contact_number: student.contact_number || "-",
    registration_date: student.registration_date || "-",
    role_name: student.role_name || "-",
  }));

  const dataTableColumns = [
    { Header: "#", accessor: "sno" },
    { Header: "Name", accessor: "name" },
    { Header: "Email", accessor: "email" },
    { Header: "Class", accessor: "student_class" },
    // { Header: "Section", accessor: "section" },
    { Header: "Roll No", accessor: "roll_number" },
    { Header: "DOB", accessor: "dob" },
    { Header: "Contact", accessor: "contact_number" },
    { Header: "Reg. Date", accessor: "registration_date" },
    { Header: "Role", accessor: "role_name" },
  ];

  return (
    <div className="container-fluid px-5 px-2">
      {loading && <p>Loading...</p>}
      {error && <p className="text-danger">Error: {error}</p>}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fw-bold">🎓 Students List</h4>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? "Close Form" : "Add Student"}
        </button>
      </div>

      {formattedStudents && formattedStudents.length > 0 ? (
        <AllFeatureDataTable
          columns={dataTableColumns}
          data={formattedStudents}
        />
      ) : (
        !loading && <p>No Students Found</p>
      )}

      {showForm && (
        <Popup
          title="🎓 Create New Student"
          minHeight="400px"
          maxWidth="800px"
          justifyContent="center"
          onClose={() => setShowForm(false)}
        >
          <CreateStudent onClose={() => setShowForm(false)} />
        </Popup>
      )}
    </div>
  );
};

export default Students;
